<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">消息提醒</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div>
                <ul class="minContent">
                    <li class="item">
                        <mt-cell>
                            <span class="title">接受消息通知</span>
                            <mt-switch v-model="value1" @change="handleChange"></mt-switch>
                        </mt-cell>                        
                    </li>
                    <li class="item">
                        <mt-cell>
                            <span class="title">通知显示消息详情</span>
                            <mt-switch v-model="value2" @change="handleChange"></mt-switch>
                        </mt-cell>
                    </li>
                </ul>
                <ul>
                    <li class="item">
                        <mt-cell>
                            <span class="title">声音</span>
                            <mt-switch v-model="value3" @change="handleChange"></mt-switch>
                        </mt-cell>                        
                    </li>
                    <li class="item">
                        <mt-cell>
                            <span class="title">振动</span>
                            <mt-switch v-model="value4" @change="handleChange"></mt-switch>
                        </mt-cell>
                    </li>
                </ul>
            </div>
        </div>
        <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
    </div>
</template>
<script>
import { Navbar, TabItem,Switch,Actionsheet } from 'mint-ui';
export default {
  data() {
    return {  
        value1:true, 
        value2:true,
        value3:false,
        value4:false,
        sheetVisible: false,
        actions:[],  
    };
  },
  computed: {},
  components: {},
  methods: {
      handleChange(event){
          console.log(event);
          if(event == true){
            this.sheetVisible = true;
          }else{
            this.sheetVisible = false;
          }
          
      }     
  },
  mounted(){
        this.actions = [{
        name: '关闭后，手机将不再接收到新消息通知。',
      },{
        name: '确认关闭',
      }];
    },           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
i.el-icon-arrow-right{
    float: right;
    color: rgba(0, 0, 0,1);
    margin-top: 0.5rem;
    font-size: 0.55rem;
    margin-right: 0.6rem
}
.minContent{
    background-color: #fff;
    margin-top: 0.2rem;
}
.title{
    color: rgba(0, 0, 0,0.7);
    font-size: 0.42rem;
    position: absolute;
    top: 0.4rem;
    left: 0.53rem;
}
ul{
    margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/msg.vue